import { createSelectionListViewContainer } from 'factories/SelectionListView'
import listActions from 'actions/lists'
import Component from 'components/Requisitions/AddItems/AddFromList/SelectList'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) => dispatch(listActions.getItems({ type: 'Product', ...params })),
  }),
})(Component)
